import React, { useEffect } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { Navigate, useLocation } from 'react-router-dom';
import auth from '../../../firebase.init';

const RequireAuth = ({children}) => {
  
    
            const [user,loading]= useAuthState(auth);
            const location = useLocation();
            if(loading){
                return( <h2 className='text-warning fw-bold'>loading going...</h2>)
            }
            if(!user){
                return <Navigate to="/login" state={{from:location}}
                replace/>
            }
    return  children;
    
};

export default RequireAuth;